export function formatTextContent(stringToFormat?: string) {
  // Some templates use \n for line breaks, replace with <br/> to render correctly
  const formattedString = stringToFormat?.replace(/\n/g, '<br/>');

  return formattedString;
}
